import { jsx } from "panel";
import { ItemsMenuEl } from "common/components/items-menu";
import { ToggleEl } from "common/components/toggle";
import { ToggleTheme } from "common/components/toggle/types";
import { DateTab } from "../types";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-date-bucket-pane"
  }, /* @__PURE__ */ jsx(ToggleEl, {
    sel: ".toggle-el",
    attrs: {
      theme: ToggleTheme.TabBar,
      options: [
        {
          label: `Unit`,
          value: DateTab.Unit,
          tooltipLabel: `Group date values by time units`
        },
        {
          label: `ISO-8601`,
          value: DateTab.Iso,
          tooltipLabel: `Group date values by ISO-8601 format`
        }
      ],
      selected: this.params.unit ? DateTab.Unit : DateTab.Iso
    },
    on: {
      select: (ev) => this.handleTabClick(ev)
    }
  }), this.params.unit && /* @__PURE__ */ jsx(ItemsMenuEl, {
    props: { sections: this.getItemsMenuSections() },
    on: {
      clickItem: (ev) => this.handleClickUnit(ev)
    }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".bucket-preview"
  }, this.getPreviewForUnit(this.params.unit)));
}
